function normaliseParticipantId(value) {
  if (value === null || value === undefined) {
    return null;
  }

  if (typeof value === "number" && Number.isFinite(value)) {
    return value;
  }

  if (typeof value === "string") {
    const trimmed = value.trim();
    if (trimmed === "") {
      return null;
    }
    const numeric = Number(trimmed);
    if (!Number.isNaN(numeric)) {
      return numeric;
    }
    return trimmed;
  }

  const numeric = Number(value);
  if (!Number.isNaN(numeric)) {
    return numeric;
  }

  return String(value);
}

function coalesce(...values) {
  for (let i = 0; i < values.length; i += 1) {
    const value = values[i];
    if (value !== null && value !== undefined && value !== "") {
      return value;
    }
  }
  return null;
}

function createReportStateFromQuery(query = {}) {
  return {
    userId: normaliseParticipantId(query.userId),
    targetUserId: normaliseParticipantId(query.targetUserId),
    reporterNickname: "",
    targetNickname: "",
    reporterUuid: null,
    targetUuid: null,
  };
}

function buildReportStateFromDetail(reportDetail = {}, fallbackState) {
  const fallback = fallbackState || createReportStateFromQuery();
  const reporter = reportDetail?.report_user ?? {};
  const target = reportDetail?.target_user ?? {};

  const reporterNickname =
    reporter?.nickname !== undefined && reporter?.nickname !== null
      ? reporter.nickname
      : fallback.reporterNickname ?? "";
  const targetNickname =
    target?.nickname !== undefined && target?.nickname !== null
      ? target.nickname
      : fallback.targetNickname ?? "";

  return {
    userId: coalesce(
      normaliseParticipantId(reporter?.id),
      fallback.userId,
      null
    ),
    targetUserId: coalesce(
      normaliseParticipantId(target?.id),
      fallback.targetUserId,
      null
    ),
    reporterNickname,
    targetNickname,
    reporterUuid: coalesce(reporter?.uuid, fallback.reporterUuid, null),
    targetUuid: coalesce(target?.uuid, fallback.targetUuid, null),
  };
}

function resetReportState(fallbackState) {
  const fallback = fallbackState || createReportStateFromQuery();
  return {
    userId: fallback.userId ?? null,
    targetUserId: fallback.targetUserId ?? null,
    reporterNickname: "",
    targetNickname: "",
    reporterUuid: null,
    targetUuid: null,
  };
}

module.exports = {
  createReportStateFromQuery,
  buildReportStateFromDetail,
  resetReportState,
};
